// صفحة «متابعة الحرارة» (pages/temp-monitoring.tsx) وبطاقة سلسلة التبريد في التتبّع.
const EN_B14: Record<string, string> = {
  "الأحد": "Sunday",
  "الإثنين": "Monday",
  "الثلاثاء": "Tuesday",
  "الأربعاء": "Wednesday",
  "الخميس": "Thursday",
  "الجمعة": "Friday",
  "السبت": "Saturday",
  "اليوم كاملاً (٢٤ ساعة)": "Full day (24 h)",
  "ساعات محددة": "Specific hours",
  "لا عمل": "No work",
  "+ فترة": "+ interval",
  "حذف": "Remove",
  "حتى اليوم التالي": "until next day",
  "انسخ الأحد لكل الأيام": "Copy Sunday to all days",
  "بتوقيت الكويت (UTC+3)": "Kuwait time (UTC+3)",
  "حفظ الجدول": "Save schedule",
  "جارٍ الحفظ…": "Saving…",
  "حُفظ — يسري من الآن، والتقارير السابقة تبقى بجدولها": "Saved — effective from now; earlier reports keep their schedule",
  "لا تغيير": "No change",
  "تعذّر الحفظ": "Couldn't save",
  "جدول ساعات العمل غير متاح الآن — لا يُفترض «اليوم كاملاً»": "Business-hours schedule unavailable — full day is not assumed",
  "ساعات عمل الحرارة (الشركة)": "Temperature business hours (company)",
  "تنبيهات الحرارة وكل أرقام الحرارة وتقاريرها تُحسب داخل هذه الساعات فقط. تنبيهات البطارية وصمت الحساس تبقى على مدار اليوم.": "Temperature alerts and all temperature figures and reports are counted within these hours only. Battery and silent-sensor warnings stay 24 hours.",
  "الحالي": "Current",
  "لم يُضبط — اليوم كاملاً": "Not set — full day",
  "سجل التغييرات": "Change history",
  "تعديل": "Edit",
  "إلغاء": "Cancel",
  "للعرض فقط — التعديل لمن يملك تعديل الأسطول": "View only — editing requires fleet edit permission",
  "ساعات عمل هذا الجهاز": "This device's business hours",
  "يرث جدول الشركة": "Inherits company schedule",
  "جدول خاص بهذا الجهاز": "Device-specific schedule",
  "حتى ٤ فترات في اليوم": "Up to 4 intervals per day",
  "أدخل الوقت بصيغة HH:MM": "Enter time as HH:MM",
  "لا ساعات عمل اليوم حتى الآن": "No business hours today so far",
  "تغطية ساعات العمل": "Business-hours coverage",
  "جدول ساعات العمل غير متاح": "Business-hours schedule unavailable",
  "جدول ساعات العمل غير متاح الآن — الأرقام محجوبة (لا يُفترض «اليوم كاملاً»). اعرض اليوم كاملاً أو أعد المحاولة.": "Business-hours schedule unavailable — figures withheld (full day is not assumed). View full day or retry.",
  "جدول ساعات العمل غير متاح — الأرقام محجوبة": "Business-hours schedule unavailable — figures withheld",
  "جدول ساعات العمل غير متاح — خط الحرارة محجوب": "Business-hours schedule unavailable — temperature line withheld",
  "خارج ساعات العمل — لا يُحسب": "Outside business hours — not counted",
  "اليوم كاملاً (عرضٌ صريح — ساعات العمل لا تُطبَّق)": "Full day (explicit view — business hours not applied)",
  "اليوم كاملاً (لا جدول ساعات عمل في هذه الفترة)": "Full day (no business-hours schedule in this period)",
  "ساعات الحساب": "Counted hours",
  "ساعات العمل": "Business hours",
  "اليوم كاملاً": "Full day",
  "ساعات العمل فقط — ما خارجها لا يُحسب": "Business hours only — time outside them is not counted",
  "اليوم كاملاً — لا جدول ساعات عمل في هذه الفترة": "Full day — no business-hours schedule in this period",
  "اليوم كاملاً — عرضٌ صريح، ساعات العمل لا تُطبَّق": "Full day — explicit view, business hours not applied",
  "دقيقة محسوبة من": "minutes counted of",
  "قراءة خارج ساعات العمل (لا تُحسب)": "readings outside business hours (not counted)",
  "لا ساعات عمل في هذه الفترة — لا حكم": "No business hours in this period — no verdict",
  "الجدول المطبّق": "Applied schedule",
  "افتراضي — لم يُضبط جدول": "Default — no schedule set",
  "جدول الشركة": "Company schedule",
  "جدول خاصّ بالجهاز": "Device-specific schedule",
  "المظلّل بالأزرق خارج ساعات العمل": "Blue-shaded areas are outside business hours",
  "بداية ساعات العمل": "Start of business hours",
  "نهاية ساعات العمل": "End of business hours",
  "ساعات عمل كاملة": "Whole business-hours window",
  "غير معروفة — عند بداية ساعات العمل": "Unknown — at the start of business hours",
  "توقّفت المتابعة — انتهت ساعات العمل (ليس عودةً إلى النطاق)": "Monitoring paused — business hours ended (not a return to range)",
  "متابعة الحرارة": "Temperature monitoring",
  "متابعة الحرارة والتقرير": "Temperature monitoring & report",
  "التتبّع": "Tracking",
  "الحساس (الجهاز)": "Sensor (device)",
  "آخر 24 ساعة": "Last 24 hours",
  "آخر 30 يوماً": "Last 30 days",
  "تنزيل PDF": "Download PDF",
  "لا أجهزة حرارة معيَّنة لشركتك": "No temperature devices assigned to your company",
  "اختر سيارة أو حساساً لعرض التقرير": "Pick a car or a sensor to view the report",
  "تعذّر تحميل التقرير": "Couldn't load the report",
  "القراءة الحالية": "Current reading",
  "عمرها": "Age",
  "حيّة": "Live",
  "صامتة — ليست حيّة": "Silent — not live",
  "المتوسط (تقدير)": "Average (estimate)",
  "التغطية": "Coverage",
  "الفجوات": "Gaps",
  "خارج النطاق (تقدير)": "Out of range (estimate)",
  "أحداث التجاوز": "Breach events",
  "منحنى الحرارة": "Temperature curve",
  "الخط ينقطع عند كل فجوة أطول من 10 دقائق · المنطقة الرمادية فجوة · الحمراء تجاوز": "The line breaks at every gap longer than 10 minutes · grey = gap · red = breach",
  "لا قراءات — لا يمكن الحكم": "No readings — no judgement possible",
  "لا حدود مضبوطة — القراءات معروضة دون حكم": "No limits set — readings shown without judgement",
  "رُصد خروجٌ عن النطاق": "Out-of-range observed",
  "لم يُرصد خروجٌ عن النطاق في الوقت المغطّى": "No out-of-range observed during covered time",
  "فوق الحد": "Above limit",
  "تحت الحد": "Below limit",
  "حالة البداية": "Start status",
  "الذروة": "Peak",
  "الموضع": "Position",
  "بلا قراءة": "Without readings",
  "غير مغطّى": "Uncovered",
  "بداية الفترة": "Period start",
  "وسط الفترة": "Mid period",
  "نهاية الفترة": "Period end",
  "الفترة كلها": "Whole period",
  "وقت الوصول إلى الخادم": "Server receipt time",
  "الأوقات هي وقت وصول القراءة إلى الخادم لا وقت قياسها في الجهاز؛ القراءات المخزّنة في الجهاز أو المتأخرة تحمل وقت وصولها.": "Times are when the reading reached the server, not when the device measured it; buffered or delayed readings carry their arrival time.",
  "تحليل وفق الحدود الحالية المحددة": "Analysed against the currently set limits",
  "تغييرات الحدود السابقة غير مسجّلة؛ حُلّلت الفترة كلها بالحدود الحالية.": "Past limit changes are not recorded; the whole period was analysed with the current limits.",
  "وقت إصدار التقرير": "Report generated at",
  "المتوسط ومدد التجاوز تقديرية: كل قراءة تغطي حتى القراءة التالية بحد أقصى 10 دقائق، وما بعدها فجوة غير محسوبة.": "Average and breach durations are estimates: each reading covers until the next one, capped at 10 minutes; beyond that is an uncounted gap.",
  "جميع الأوقات بتوقيت الكويت (UTC+3)": "All times in Kuwait time (UTC+3)",
  "هذه قراءات الجهاز؛ لا يمكن إثبات نسبتها لهذه السيارة قبل تاريخ التعيين": "These are the device's readings; they cannot be proven to belong to this car before the assignment date",
  "القراءات قبل تعيين الجهاز لشركتك لا تُعرض — بداية الفترة الفعلية:": "Readings before the device was assigned to your company are not shown — effective period start:",
  "تقرير متابعة تشغيلي — ليس شهادة ولا وثيقة امتثال": "Operational monitoring report — not a certificate or compliance document",
  "الفترة المطلوبة": "Requested period",
  "البيانات الموجودة": "Data found",
  "أول قراءة / آخر قراءة": "First / last reading",
  "الفترة المخصّصة أطول من 31 يوماً": "Custom period is longer than 31 days",
  "أدخل تاريخاً ووقتاً كاملين في «من» و«إلى»": "Enter a complete date and time in “From” and “To”",
  "بداية الفترة يجب أن تسبق نهايتها، ولا تكون بعد الوقت الحالي": "The period must start before it ends, and not after the current time",
  "تعذّر التنزيل": "Download failed",
  "بعد قراءةٍ داخل النطاق": "After an in-range reading",
  "بعد تجاوزٍ معاكس": "After an opposite breach",
  "غير معروفة — عند بداية الفترة": "Unknown — at period start",
  "غير معروفة — بعد فجوة": "Unknown — after a gap",
  "عاد إلى النطاق": "Returned to range",
  "انتقل إلى تجاوزٍ معاكس": "Switched to opposite breach",
  "غير معروفة — بدأت فجوة": "Unknown — a gap began",
  "غير معروفة — انتهت الفترة والتجاوز قائم": "Unknown — period ended during the breach",
  "تقدير": "estimate",
  "غير معروفة — ≥": "Unknown — ≥",
  "مرصودة": "observed",
  "تعذّر حساب تجاوز اليوم": "Couldn't compute today's breaches",
  "تغطية": "coverage",
  "الحساس صامت — لا قراءات اليوم": "Sensor silent — no readings today",
  "لا قراءات اليوم": "No readings today",
  "متأخرة الوصول": "Delayed",
  "قراءات حرارة": "temperature readings",
  "تخزين جدول ساعات العمل غير مكتمل (حماية سجلّ النسخ ناقصة) — الحفظ معطَّل حتى تكتمل ترقية قاعدة البيانات": "Business-hours schedule storage is incomplete (version-history protection missing) — saving is disabled until the database upgrade completes",
  "تغيّر العرض أثناء إصدار الشهادة — لم تُفتح. أعد المحاولة بعد اكتمال التحميل": "The view changed while issuing the certificate — it was not opened. Retry once loading completes",
};
export default EN_B14;
